import script from "./SalesRebateRecord.vue?vue&type=script&lang=ts&setup=true"
export * from "./SalesRebateRecord.vue?vue&type=script&lang=ts&setup=true"

import "./SalesRebateRecord.vue?vue&type=style&index=0&id=646ba66c&lang=css"

const __exports__ = script;

export default __exports__